import * as React from 'react';
import { listenToPlanChange, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import Plan from '../buy/Plan';
import RowWithButton from './components/RowWithButton';
import { callFunction } from '../utils/FirebaseUtils';
import { trackEvent } from '../utils/Tracker';
import { useUser } from 'hooks/useUser';

const HOUR_IN_MILLIS = 1000 * 60 * 60;
const DAY_IN_MILLIS = HOUR_IN_MILLIS * 24;

const PlanRow: React.FC = () => {
  const [processing, setProcessing] = React.useState(false);
  const [portalUrl, setPortalUrl] = React.useState<string | undefined>(
    undefined
  );
  const user = useUser();

  const upgrade = React.useCallback(() => {
    trackEvent('Clicked Upgrade', { location: 'Account settings' });
    storeDispatch(Actions.showBuyingOptions());
  }, []);

  const manageSubscription = React.useCallback(async () => {
    if (portalUrl) {
      window.open(portalUrl, '_blank');
      return;
    }
    if (user && user.customerId) {
      trackEvent('Generate Portal URL');
      setProcessing(true);
      let url: string | undefined;
      // TODO: start tracking user plan changes
      try {
        const result = await callFunction(
          'createCustomerPortalSession',
          user.customerId
        );
        url = result.data as string;
        window.open(url, '_blank');
      } catch (e) {
        alert(e.message);
      }
      setPortalUrl(url);
      setProcessing(false);
      listenToPlanChange();
    } else {
      alert('User customer ID is missing');
    }
  }, [portalUrl, user]);

  let plan: Plan | null = null;
  let value: string | null = null;
  let meta: string | null = null;
  let planExpiration = 0;
  if (user && user.plan) {
    plan = user.plan;
    value = user.plan.split('.').pop() as string;
    planExpiration = user.planExpiration;
  }
  let buttonLabel = '';
  let handler = () => {
    /* do nothing */
  };
  if (plan) {
    switch (plan) {
      case Plan.Free:
        buttonLabel = 'Upgrade';
        handler = upgrade;
        break;
      case Plan.ProDay:
        value = 'day pass';
        buttonLabel = processing ? 'Extending...' : 'Extend';
        const hours = Math.round(
          (planExpiration - Date.now()) / HOUR_IN_MILLIS
        );
        meta = `${hours} hours left`;
        handler = upgrade;
        break;
      case Plan.ProMonthly:
      case Plan.ProYearly:
        value = plan.split('.').pop() as string;
        if (planExpiration > 0) {
          const days = Math.round(
            (planExpiration - Date.now()) / DAY_IN_MILLIS
          );
          meta = `${days} days left`;
        }
        buttonLabel = processing ? 'Opening...' : 'Manage';
        handler = manageSubscription;
        break;
      default:
        break;
    }
  }

  return (
    <RowWithButton
      label="Subscription"
      value={value}
      meta={meta}
      disabled={processing}
      buttonLabel={buttonLabel}
      onClick={handler}
    />
  );
};

export default PlanRow;



// WEBPACK FOOTER //
// ./src/account/PlanRow.tsx